import { render } from "./compose-index.vue?vue&type=template&id=6ad99f4e"
import script from "./compose-index.vue?vue&type=script&lang=js"
export * from "./compose-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__